/**
 * ChipExpansionPanel.js — Container for the expanded chip edit form
 *
 * Appears below the ChipRow when a chip is expanded.
 * Contains the appropriate form (ConditionForm, CostForm, or EffectForm)
 * and a "Done" button to collapse.
 */

import { cn } from '../../../../lib/utils';
import ConditionForm from '../forms/ConditionForm';
import CostForm from '../forms/CostForm';
import EffectForm from '../forms/EffectForm';

const BORDER_COLORS = {
  condition: 'border-blue-600',
  cost: 'border-amber-600',
  effect: 'border-green-600',
};

const ChipExpansionPanel = ({ item, index, chipType, colorScheme, onUpdate, onDone }) => {
  const borderColor = BORDER_COLORS[chipType] || 'border-gray-600';

  const handleUpdate = (updated) => {
    onUpdate(index, updated);
  };

  const renderForm = () => {
    switch (chipType) {
      case 'condition':
        return <ConditionForm condition={item} onUpdate={handleUpdate} />;
      case 'cost':
        return <CostForm cost={item} onUpdate={handleUpdate} />;
      case 'effect':
        return <EffectForm effect={item} onUpdate={handleUpdate} />;
      default:
        return null;
    }
  };

  return (
    <div className={cn('mt-2 p-3 bg-gray-900/80 border rounded-lg', borderColor)}>
      {renderForm()}
      <button
        type="button"
        onClick={onDone}
        className={cn(
          'mt-3 px-3 py-1.5 text-sm rounded-md',
          'bg-gray-700 text-white hover:bg-gray-600 transition-colors'
        )}
      >
        Done
      </button>
    </div>
  );
};

export default ChipExpansionPanel;
